import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import { 
    GET_PROFILE,
    UPDATE_PROFILE,
} from "./actionTypes";

import { 
    getProfileSuccess, 
    getProfileError,

    updateProfileSuccess,
    updateProfileError

} from "./actions";

import { 
    getProfile,
    updateProfile,

} from "helpers/accounts/accounts_backend_helper"; 

import { toast } from "react-toastify";

function* fetchProfile() {
  try {
    const response = yield call(getProfile);
    yield put(getProfileSuccess(response));
  } catch (error) {
    yield put(getProfileError(error));
  }
}

function* onUpdateProfile({ payload }) {
  try {
    const response = yield call(updateProfile, payload);
    yield put(updateProfileSuccess(response));
    toast.success(response.message, { autoClose: 2000 });
  } catch (error) {
    yield put(updateProfileError(error));
    toast.error(error.response?.data?.error || "Impossible de mettre à jour le profil", { autoClose: 2000 });
  }
}

function* watchGetProfile() {
  yield takeEvery(GET_PROFILE, fetchProfile);
  yield takeEvery(UPDATE_PROFILE, onUpdateProfile);
}

export default function* profileSaga() {
  yield all([fork(watchGetProfile)]);
}
